import React from "react";
import styled from "styled-components";

import TopSectionBackgroundImg from "../../images/background10.jpg"

import BestStandoutImage from "../../images/standout5.png"

import { BrandLogo } from "../../Components/brandLogo"
import { Marginer } from "../../Components/marginer"

import Button from "@material-ui/core/Button"
import { Link } from "react-scroll"

const TopSectionContainer = styled.div`
	width: 100%;
	height: 700px;
	background: url(${TopSectionBackgroundImg});
	background-position: 0px -150px;
	background-size: column;
`;

const BackgroundFilter = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(38, 70, 83, 0.9);
	display: flex;
	flex-direction: cover;

`;


const TopSectionInnerContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
`;

const StandoutImage = styled.div`
	width: 24em;
	height: 16em;

	img{
		width: 100%;
		height: 100%;
	}
`;

const LogoContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex;
`;

const SloganText = styled.h3`
	margin: 0;
	line-height: 1.4;
	color: #fff;
	font-weight: 400;
	font-size: 30px;
`;

export function TopSection(props){
	return <TopSectionContainer>
	<BackgroundFilter>
	<TopSectionInnerContainer>
	<LogoContainer>
		<BrandLogo />
		<Marginer direction="vertical" margin={8} />
		<SloganText> Easily Build your Portfolio </SloganText>
		<Marginer direction="vertical" margin={15} />
		<Link to="inputsect" spy={true} smooth={true}>
		<Button style={{maxWidth: '140px', maxHeight: '40px', minWidth: '100px', minHeight: '40px',
		 textTransform: 'capitalize', fontSize: '18px', fontWeight: "bold"}} 
		variant="contained" color="secondary" disableElevation
		size="medium">Get Started</Button>
		</Link>
	</LogoContainer>
	<StandoutImage>
		<img src={BestStandoutImage} alt="Code" />
	</StandoutImage>
	</TopSectionInnerContainer>
	</BackgroundFilter>
	</TopSectionContainer>
} 